import React, { Component } from "react";
import "./Welcome.scss";

const initialState = {
    isMenuSummaryActive: false,
    isMenuDatesActive: false
}

export default class Welcome extends Component {
    static getDerivedStateFromProps(props, state) {
        // console.log(props.Sokrim);
        return {
            Sokrim: props.Sokrim,
            dates: props.dates,
            currentSoker: state.currentButton != props.activeButton ? 0 : state.currentSoker,
            currentDate: state.currentButton != props.activeButton ? 0 : state.currentDate,
            currentButton: props.activeButton
        }
    }
    constructor() {
        super();
        this.state = {
            ...initialState,
            dates: [],
            Sokrim: [],
            currentSoker: 0,
            currentDate: 0,
            isBusy: false,
            currentButton: 0
        }
    }
    componentDidMount() {
        this.setState({
            Sokrim: this.props.Sokrim,
            dates: this.props.dates
        })
    }
    resetMenuState = () => {
        this.setState({
            ...initialState
        })
    }
    changeMenuState = state => {
        this.setState({
            ...initialState,
            [state]: !this.state[state],
            isBusy: true
        })
    }
    setSokrimButtonValue = index => {
        this.setState({
            currentSoker: index
        }, () => {
            this.sokrimList.scrollTop = 0;
            let { Sokrim, currentSoker, dates } = this.state;
            if (currentSoker != null) {
                this.setState({
                    // Sokrim,
                    // currentSoker: 0
                }, () => {
                    this.sokrimList.scrollTop = 0;
                    this.props.setSokrimButtonValue(Sokrim[currentSoker]);
                });
            }
        });
    }
    setDateButtonValue = index => {
        this.setState({
            currentDate: index
        }, () => {
            this.dateList.scrollTop = 0;
            let { dates, currentDate, currentSoker, Sokrim } = this.state;
            if (currentDate != null) {
                this.setState({
                    // dates,
                    // currentDate: 0
                }, () => {
                    this.dateList.scrollTop = 0;
                    this.props.setDateButtonValue(dates[currentDate], Sokrim[currentSoker]);
                });
            }
        });
    }
    renderSokrim() {
        let { Sokrim } = this.state;
        if (this.sokrimList) {
            this.sokrimList.scrollTop = 0;
        }
        return Sokrim.map((item, index) =>
            <div className="option" key={index} onClick={() => this.setSokrimButtonValue(index)}>
                {item.PollAuthorLabel}
            </div>
        )
    }
    renderDates() {
        let { dates } = this.state;
        const currentDate = new Date();
        if (this.dateList) {
            this.dateList.scrollTop = 0;
        }
        if (dates.length == 0) {
            return <div className="option line"></div>
        }
        return dates.map((item, index) =>
            <div className="option" key={index} onClick={() => !this.isDisabledButton() ? this.setDateButtonValue(index) : null}>
                {/* ${currentDate.getDate().toString() == item.split(".")[0] ? "היום - " : ""} */}
                {(typeof item == "object" ? item.label : `${item}`)}
            </div>
        )
    }
    isDisabledButton = () => {
        const { Sokrim, currentSoker } = this.state;
        if(!Sokrim[currentSoker]) return;
        return Sokrim[currentSoker].PollAuthor == -1;
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="overlay">
                    <div className="bg"></div>
                </div>
                <div className="padding">
                    <div className="container">
                        <div className="headline">
                            <div className="head">
                                <div className="elections-head"></div>
                                <div className="head-logo">
                                    <img src={require("../../static/images/mobile/ynet.png")} />
                                    {/* <div className="ynet"></div> */}
                                    <div className="head-text">בחירות 
                                    <span>2022</span>
                                    </div>
                                    <div className="head-line"></div>
                                </div>
                                {/* <div className="line"></div>
                                <div className="head-text">בחירות 2022</div> */}
                            </div>
                            <div className="desc">
                                מספר המנדטים לפי הסקרים האחרונים
                            </div>
                        </div>
                        <div className="buttons">
                            <div className="row">
                                <div className={`button ${this.props.activeButton == 0 ? " active" : ""}`} onClick={() => { this.resetMenuState(); this.props.setActiveButton(0) }}>
                                    לפי סקר
                                </div>
                                <div className={`button ${this.props.activeButton == 1 ? " active" : ""}`} onClick={() => { this.resetMenuState(); this.props.setActiveButton(1) }}>
                                    לפי מפלגה
                                 </div>
                            </div>
                            <div className="row">
                                <div className={`button dropdown ${this.state.isMenuSummaryActive ? " active" : ""}`}>
                                    <div
                                        onClick={() => this.changeMenuState("isMenuSummaryActive")}
                                        className={`options${this.state.isMenuSummaryActive ? " active" : ""}`}>
                                        <div className="arrow"></div>
                                        <div className="options-list" ref={sokrimList => this.sokrimList = sokrimList}>
                                            {this.state.Sokrim[this.state.currentSoker] != null ?
                                                <div className="option placeholder"
                                                    onClick={() => this.changeMenuState("isMenuSummaryActive")}>{this.state.Sokrim[this.state.currentSoker].PollAuthorLabel}</div> : ""}
                                            {this.renderSokrim()}
                                        </div>
                                    </div>
                                </div>
                                <div className="button dropdown">
                                    <div
                                        onClick={() => !this.isDisabledButton() ? this.changeMenuState("isMenuDatesActive") : null}
                                        className={`options ${this.isDisabledButton() ? "disabled" : ""} ${this.state.isMenuDatesActive ? " active" : ""}`}>
                                        <div className="arrow"></div>
                                        <div className="options-list" ref={dateList => this.dateList = dateList}>
                                            {this.state.dates[this.state.currentDate] != null ?
                                                <div className="option placeholder"
                                                    onClick={() => !this.isDisabledButton() ? this.changeMenuState("isMenuDatesActive") : null}>{this.state.dates[this.state.currentDate].label ? this.state.dates[this.state.currentDate].label : this.state.dates[this.state.currentDate]}</div> : ""}
                                            {this.renderDates()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx